window.ImagineTheme = window.ImagineTheme || {};

(function () {
  "use strict";

  var selectors = {
    overlay: "[data-imagine-overlay]",
    drawer: "[data-imagine-drawer]",
    closeDrawer: "[data-imagine-close-drawer]",
    openMenu: "[data-imagine-open-menu]",
    menuDrawer: "[data-imagine-menu-drawer]",
    footerToggle: "[data-imagine-footer-toggle]",
    wishlist: "[data-imagine-wishlist]",
    cartCount: "[data-imagine-cart-count]",
    wishlistCount: "[data-imagine-wishlist-count]"
  };

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function isShopifyDesignMode() {
    return document.documentElement.classList.contains("shopify-design-mode") ||
      document.body.classList.contains("shopify-design-mode");
  }

  function resetHeaderVisibility(header) {
    [header, qs(".imagine-header", header)].forEach(function (element) {
      if (!element) return;
      element.classList.remove("is-hidden", "header-hidden", "scroll-down", "translate-up", "hide-header");
      element.style.transform = "none";
      element.style.opacity = "1";
      element.style.visibility = "visible";
    });
  }

  function focusable(root) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
      .filter(function (element) {
        return element.offsetWidth || element.offsetHeight || element === document.activeElement;
      });
  }

  function trapFocus(container, event) {
    if (event.key !== "Tab") return;
    var items = focusable(container);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function overlay() {
    return qs(selectors.overlay);
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    if (overlay()) overlay().classList.add("is-open");
    document.documentElement.setAttribute("scroll-lock", "");
    var first = focusable(drawer)[0];
    if (first) first.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    if (!qs(".imagine-drawer.is-open") && overlay()) overlay().classList.remove("is-open");
    if (!qs(".imagine-drawer.is-open")) document.documentElement.removeAttribute("scroll-lock");
  }

  function closeAllDrawers() {
    qsa(".imagine-drawer.is-open").forEach(closeDrawer);
  }

  function toast(message) {
    var region = qs("[data-imagine-toast-region]");
    if (!region) {
      region = document.createElement("div");
      region.className = "imagine-toast-region";
      region.setAttribute("data-imagine-toast-region", "");
      region.setAttribute("aria-live", "polite");
      region.setAttribute("aria-atomic", "true");
      document.body.appendChild(region);
    }
    var item = document.createElement("div");
    item.className = "imagine-toast";
    item.setAttribute("role", "status");
    item.textContent = message;
    region.appendChild(item);
    window.setTimeout(function () {
      item.remove();
    }, 3000);
  }

  function updateCartCount(count) {
    qsa(selectors.cartCount).forEach(function (badge) {
      badge.textContent = String(count || 0);
      badge.hidden = !count;
    });
  }

  function wishlistItems() {
    try {
      return JSON.parse(localStorage.getItem("imagineWishlist") || "[]");
    } catch (error) {
      return [];
    }
  }

  function setWishlistItems(items) {
    items = Array.isArray(items) ? items.filter(Boolean).filter(function (item, index, array) {
      return array.indexOf(item) === index;
    }) : [];
    try {
      localStorage.setItem("imagineWishlist", JSON.stringify(items));
    } catch (error) {
      return;
    }
    updateWishlistUI(items);
    window.dispatchEvent(new CustomEvent("imagine:wishlist-updated", {
      detail: {
        count: items.length,
        items: items
      }
    }));
  }

  function updateWishlistUI(items) {
    items = items || wishlistItems();
    qsa(selectors.wishlistCount).forEach(function (badge) {
      badge.textContent = String(items.length);
      badge.hidden = items.length === 0;
    });
    qsa(selectors.wishlist).forEach(function (button) {
      var active = items.indexOf(button.getAttribute("data-imagine-wishlist")) > -1;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    });
  }

  function initHeader(root) {
    qsa("[data-imagine-header]", root).forEach(function (header) {
      if (isShopifyDesignMode()) {
        resetHeaderVisibility(header);
        return;
      }

      if (header.dataset.imagineBound) return;
      header.dataset.imagineBound = "true";
      var scrollContainer = qs(".page-wrapper") || window;
      var stickyBehavior = header.getAttribute("data-imagine-sticky-behavior") || "always";
      var lastTop = scrollContainer === window ? window.scrollY : scrollContainer.scrollTop;

      header.classList.remove("is-hidden", "header-hidden", "scroll-down", "translate-up", "hide-header");
      header.style.transform = "";
      header.style.opacity = "";
      header.style.visibility = "";

      var sync = function () {
        var top = scrollContainer === window ? window.scrollY : scrollContainer.scrollTop;
        var headerHeight = header.offsetHeight || 0;

        header.classList.toggle("is-scrolled", top > 8);

        if (stickyBehavior === "scroll_up") {
          if (top <= headerHeight || top < lastTop - 4) {
            header.classList.remove("is-hidden");
          } else if (top > headerHeight && top > lastTop + 4) {
            header.classList.add("is-hidden");
          }
        } else {
          header.classList.remove("is-hidden");
        }

        lastTop = Math.max(top, 0);
      };
      sync();
      scrollContainer.addEventListener("scroll", sync, { passive: true });
    });
  }

  function initDrawers(root) {
    qsa(selectors.openMenu, root).forEach(function (button) {
      if (button.dataset.imagineBound) return;
      button.dataset.imagineBound = "true";
      button.addEventListener("click", function () {
        openDrawer(qs(selectors.menuDrawer));
      });
    });

    qsa("[data-imagine-open-drawer]", root).forEach(function (button) {
      if (button.dataset.imagineBound) return;
      button.dataset.imagineBound = "true";
      button.addEventListener("click", function () {
        openDrawer(qs(button.getAttribute("data-imagine-open-drawer")));
      });
    });

    qsa(selectors.closeDrawer, root).forEach(function (button) {
      if (button.dataset.imagineBound) return;
      button.dataset.imagineBound = "true";
      button.addEventListener("click", function () {
        closeDrawer(button.closest(selectors.drawer));
      });
    });

    qsa(selectors.drawer, root).forEach(function (drawer) {
      if (drawer.dataset.imagineTrapBound) return;
      drawer.dataset.imagineTrapBound = "true";
      drawer.addEventListener("keydown", function (event) {
        trapFocus(drawer, event);
      });
    });

    if (overlay() && !overlay().dataset.imagineBound) {
      overlay().dataset.imagineBound = "true";
      overlay().addEventListener("click", closeAllDrawers);
    }
  }

  function initFooter(root) {
    qsa(selectors.footerToggle, root).forEach(function (button) {
      if (button.dataset.imagineBound) return;
      button.dataset.imagineBound = "true";
      button.addEventListener("click", function () {
        var column = button.closest(".imagine-footer__column");
        if (!column) return;
        var open = column.classList.toggle("is-open");
        button.setAttribute("aria-expanded", String(open));
      });
    });
  }

  function initWishlist(root) {
    qsa(selectors.wishlist, root).forEach(function (button) {
      if (button.dataset.imagineBound) return;
      button.dataset.imagineBound = "true";
      button.addEventListener("click", function (event) {
        event.preventDefault();
        var handle = button.getAttribute("data-imagine-wishlist");
        var items = wishlistItems();
        var exists = items.indexOf(handle) > -1;
        items = exists ? items.filter(function (item) { return item !== handle; }) : items.concat(handle);
        setWishlistItems(items);
        toast(exists ? "Removed from wishlist." : "Added to wishlist.");
      });
    });
    updateWishlistUI();
  }

  function init(root) {
    root = root || document;
    initHeader(root);
    initDrawers(root);
    initFooter(root);
    initWishlist(root);
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeAllDrawers();
  });

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
    if (window.ImagineSlider) window.ImagineSlider.init(event.target);
    if (window.ImagineSearch) window.ImagineSearch.init(event.target);
    if (window.ImagineCartDrawer) window.ImagineCartDrawer.init(event.target);
  });

  document.addEventListener("shopify:section:select", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:section:reorder", function () {
    init(document);
  });

  window.addEventListener("storage", function (event) {
    if (event.key === "imagineWishlist") updateWishlistUI();
  });

  window.ImagineTheme.init = init;
  window.ImagineTheme.openDrawer = openDrawer;
  window.ImagineTheme.closeDrawer = closeDrawer;
  window.ImagineTheme.closeAllDrawers = closeAllDrawers;
  window.ImagineTheme.toast = toast;
  window.ImagineTheme.updateCartCount = updateCartCount;
  window.ImagineTheme.getWishlistItems = wishlistItems;
  window.ImagineTheme.setWishlistItems = setWishlistItems;
  window.ImagineTheme.updateWishlistUI = updateWishlistUI;
})();
